<!-- Card List Content -->

<div class="" [ngClass]="[!token || isLandingPage ? 'bg-[#0A0E1F]' : '']">
  <!-- Card List Header Section -->
  <!-- <div *ngIf="!token || isLandingPage" class="easy-steps-header max-w-3xl mx-auto text-center px-4">
    <span class="text-[#7de7e5] text-sm font-semibold tracking-widest uppercase block pt-10">Available Scratch
      Cards</span>

    <h2 class="text-white text-2xl md:text-3xl font-bold mb-4" id="scrach-card-scrolling-id">
      It’s Try Your Luck & Win Big!
    </h2>

    <p class="text-gray-400 text-base md:text-lg leading-relaxed mb-10">
      Scratch, reveal, and win instantly! Every card hides a surprise — from
      bonus points to big rewards. Your next big win could be just one scratch
      away.
    </p>
  </div> -->
  @if (isHomePage && !isScratchCardPage) {
    <div class="flex flex-col items-center pb-12">
      <h2
        class="lg:text-[22px] text-white font-libre font-bold text-[18px] leading-[27px]"
      >
        <span class="text-[#19E4E0] border-b-2 border-[#19E4E0]"
          >Available</span
        >
        Mystery Cards
      </h2>
      <h1 class="text-2xl lg:text-[42px] font-bold mt-2">
        Reveal Your Daily Bonus Tokens!
      </h1>
      <p
        class="mt-3 text-[12px] lg:text-[16px] text-gray-400 text-center max-w-2xl px-4"
      >
        Match, reveal, and score instantly! Every card hides a fun surprise —
        from bonus points to premium game tokens. Your next level-up boost could
        be just one match away.
      </p>
    </div>
  }
  <div class="flex justify-end mt-2 mr-2">
    <button class="playbook-btn" (click)="showGuide()">
      <span class="relative z-10 tracking-wide">Playbook</span>
    </button>
  </div>
  <div *ngIf="!isLandingPage && !isDashboardPage">
    <div
      class="flex flex-col lg:flex-row lg:justify-between lg:relative top-12 min-h-fit align-bottom items-end px-2 lg:px-6"
    >
      <!-- <button
        class="px-6 h-fit flex py-3 rounded-xl bg-white/10 backdrop-blur-md border border-cyan-400 text-cyan-300 font-semibold shadow-[0_0_15px_rgba(34,211,238,0.6)] hover:shadow-[0_0_25px_rgba(34,211,238,0.9)] hover:scale-105 transition-all duration-300 overflow-hidden"
        (click)="showGuide()"
      >
        <span
          class="absolute inset-0  --button opacity-20 blur-xl animate-pulse"
        ></span>
        <span class="relative z-10 tracking-wide">Playbook</span>
      </button> -->

      <!-- <div class="flex items-center justify-center mt-4">
        <div class="inline-flex rounded-lg border border-[#2ee4e8] overflow-hidden rounded-tr-none rounded-br-none">
          <button (click)="showGuide()"
            class="bg-[#2ee4e8] hover:bg-[#26c0c3] text-black px-4 py-2 font-semibold focus:outline-none border-l">
            Playbook
          </button>
        </div>
      </div> -->
      <div class="flex flex-col">
        <!-- Dropdown for all screens -->
        <div
          class="reset-btn h-12 flex flex-col sm:flex-row items-center justify-end"
        >
          <div
            class="flex sm:flex-row items-center space-y-1 sm:space-y-0 sm:space-x-3 transition-opacity duration-300 ease-in-out"
            [class.opacity-0]="!showDateFilter"
            [class.pointer-events-none]="!showDateFilter"
          >
            <div
              class="relative flex items-center border border-[#2ee4e8] rounded-tl-lg rounded-bl-lg overflow-hidden cursor-pointer w-full sm:w-auto"
            >
              <input
                type="date"
                [(ngModel)]="startDate"
                (ngModelChange)="onStartDateChange($event)"
                class="text-[#2ee4e8] bg-transparent focus:ring-[#2ee4e8] focus:border-[#2ee4e8] py-1 pl-4 pr-1 outline-none cursor-pointer"
              />
            </div>

            <div
              class="relative flex items-center border border-[#2ee4e8] rounded-none overflow-hidden cursor-pointer w-full sm:w-auto"
            >
              <input
                type="date"
                [(ngModel)]="endDate"
                [min]="startDate || null"
                class="text-[#2ee4e8] bg-transparent focus:ring-[#2ee4e8] focus:border-[#2ee4e8] py-1 pl-4 pr-1 outline-none cursor-pointer"
              />
            </div>

            <button
              (click)="resetDates()"
              class="sm:w-auto border border-[#2ee4e8] text-[#2ee4e8] hover:bg-[#2ee4e8] hover:text-white rounded-tr-lg rounded-br-lg py-1 px-3"
            >
              Reset
            </button>
          </div>
        </div>
        <div
          class="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-2 w-full"
        >
          <div class="flex items-center gap-4 w-full mt-2 sm:w-auto"></div>

          <!-- Right side (Search) -->
          <div
            class="flex sm:flex-row items-end ml-10 lg:ml-0 justify-end text gap-2 w-[92vw] lg:w-[30rem]"
          >
            <!-- <span
              (click)="showDateFilter = !showDateFilter"
              class="cursor-pointer"
            >
              <svg
                class="w-7 h-7 text-cyan-400 hover:text-cyan-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
            </span> -->
            <!-- <div class="relative flex-1 text-center">
              <input
                type="text"
                placeholder="Search..."
                [(ngModel)]="searchTerm"
                class="w-full bg-transparent text-white border border-[#2ee4e8] text-sm rounded-tl-lg rounded-bl-lg rounded-tr-none rounded-br-none py-2 px-4 pl-10 focus:outline-none focus:ring-2 focus:ring-cyan-400"
              />
              <svg
                class="w-5 h-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </div>
            <button
              (click)="(true)"
              class="bg-[#2ee4e8] hover:bg-[#26c0c3] text-black px-4 py-2 rounded-tr-lg rounded-br-lg rounded-tl-none rounded-bl-none"
            >
              Search
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- card start here  -->

  <div
    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 px-2 gap-6 pt-4 overflow-auto"
    [ngClass]="{
      'container mx-auto': isLandingPage,
    }"
  >
    <div *ngFor="let card of scratchCards" class="relative w-full mx-auto">
      <!-- Background Image -->
      <img
        [src]="card.bgImage"
        alt="Loading..."
        class="w-full rounded-xl h-[260px] lg:h-[270px]"
      />

      <!-- Overlay Content -->
      <div class="absolute inset-0 text-white">
        <!-- Price Tag -->
        <div
          class="absolute mt-2 left-1/2 -translate-x-1/2 border border-yellow-400 rounded-full px-10 py-1 text-white text-md text-[16px] font-semibold shadow-lg z-10"
        >
          <span class="text-yellow-400">$</span> {{ card.ticketprice }}
        </div>

        <div class="px-5 pt-3 lg:pt-8">
          <!-- Game Icon + Title -->
          <div class="w-full mt-4 sm:mt-0">
            <svg
              width="100%"
              height="60"
              viewBox="0 0 340 60"
              preserveAspectRatio="xMidYMid meet"
            >
              <defs>
                <!-- Gold Gradient -->
                <linearGradient
                  id="goldGradient"
                  x1="0%"
                  y1="0%"
                  x2="0%"
                  y2="100%"
                >
                  <stop offset="0%" stop-color="#FFFACD" />
                  <stop offset="40%" stop-color="#FFD700" />
                  <stop offset="70%" stop-color="#E6B800" />
                  <stop offset="100%" stop-color="#A67C00" />
                </linearGradient>
              </defs>

              <!-- Main 3D Text -->
              <text
                x="10"
                y="45"
                fill="url(#goldGradient)"
                font-size="26"
                font-weight="900"
                style="
                  filter: drop-shadow(1px 1px 0 #7a5a00)
                    drop-shadow(2px 2px 0 #5c4300)
                    drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.4));
                "
              >
                {{ card.title }}
              </text>

              <!-- Highlight -->
              <text
                x="10"
                y="45"
                fill="rgba(255,255,255,0.35)"
                font-size="26"
                font-weight="900"
              >
                {{ card.title }}
              </text>
            </svg>
          </div>
          <!-- Winning Amount -->

          <!-- Scratch Area -->
          <div class="flex items-center justify-between">
            <div class="flex flex-col w-[150px] lg:w-[210px] gap-2">
              <p class="text-md mb-1 text-center font-semibold">
                Scratch your winning
              </p>
              <!-- Scratch Box -->
              <div class="w-full h-[55px] p-[3px] bg-[#0A5762] rounded-md">
                <div
                  class="w-full h-full bg-gray-400 rounded-md relative overflow-hidden"
                >
                  <!-- Dotted Grain Overlay -->
                  <div
                    class="absolute inset-0 pointer-events-none"
                    style="
                      background-image: radial-gradient(
                        rgba(0, 0, 0, 0.137) 1px,
                        transparent 1px
                      );
                      background-size: 4px 4px;
                    "
                  ></div>
                </div>
              </div>
              <!-- Button -->
              <button
                (click)="goToBuyNow(card)"
                class="relative w-full flex items-center justify-center py-2 rounded-full bg-white/3 border border-white/10 backdrop-blur-md text-white font-bold text-[14px] transition-all hover:bg-white/10 hover:border-white/40 shadow-[inset_0_0_8px_rgba(255,255,255,0.1),0_3px_8px_rgba(0,0,0,0.4)]"
              >
                <!-- Soft white overlay from top -->
                <span
                  class="absolute inset-0 rounded-full bg-gradient-to-b from-white/20 to-transparent pointer-events-none"
                ></span>
                <!-- Button content -->
                <span class="relative flex items-center gap-1.5">
                  <span>Buy Now</span>
                </span>
              </button>
            </div>

            <!-- Treasure Image -->
            <div class="flex items-center justify-center">
              <div class="absolute top-12 right-4 text-center mr-6 z-40">
                <p
                  class="text-[13px] font-semibold text-white drop-shadow-[0_2px_3px_rgba(0,0,0,0.8)]"
                >
                  Win upto!
                </p>
                <p
                  class="text-3xl font-extrabold tracking-wide bg-gradient-to-b from-[#FFF9C4] via-[#FFD700] to-[#B8860B] bg-clip-text text-transparent [text-shadow: 0_1px_0_#fff,0_2px_0_#f7d94c,0_3px_0_#e6c200,0_4px_0_#c9a400,0_5px_0_#a17c00,0_6px_4px_rgba(0,0,0,0.6),0_10px_10px_rgba(0,0,0,0.5) ]"
                >
                  {{ card.winning }}
                </p>
              </div>
              <img
                [src]="card.treasure"
                alt="Treasure"
                class="w-[150px] h-[160px] lg:w-[200px] lg:h-[150px] object-contain scale-110 drop-shadow-[0_10px_20px_rgba(0,0,0,0.6)] transition duration-500 hover:scale-125"
              />
            </div>
          </div>
        </div>
        <!-- Button -->
      </div>
    </div>
  </div>
</div>
